const e = {
  "ld.startEditing": "Comece a editar.",
  "ld.dashboard": "Meu painel de controle",
  "ld.search": "Busca",
  "ld.browse": "Navegar",
  "ld.reset": "Redefinir",
  "ld.searchResource": "Buscar recursos",
  "ld.create": "Criar recurso",
  "ld.edit": "Editar",
  "ld.editResource": "Editar recurso",
  "ld.main": "Principal",
  "ld.and": "AND",
  "ld.or": "OR",
  "ld.not": "NOT",
  "ld.saveRd": "Salvar recurso",
  "ld.closeRd": "Fechar recurso",
  "ld.deleteRd": "Excluir recurso",
  "ld.resources": "Recursos",
  "ld.searchBy": "Buscar por",
  "ld.searchFor": "Buscar por",
  "ld.searchAndFilter": "Buscar e filtrar",
  "ld.enterSearchCriteria": "Insira os critérios para iniciar a busca",
  "ld.chooseFilterOrEnterSearchQuery": "Escolha um filtro ou insira uma consulta de busca para mostrar os resultados.",
  "ld.searchNoRdsMatch": "Nenhuma descrição de recurso corresponde à sua consulta",
  "ld.searchBySth": "Buscar por {by}...",
  "ld.errorFetching": "Erro ao buscar dados",
  "ld.errorLoadingResource": "Erro ao carregar recurso",
  "ld.actions": "Ações",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LCNAF",
  "ld.title": "Título",
  "ld.contributor": "Colaborador",
  "ld.author": "Autor",
  "ld.pubDate": "Data de publicação",
  "ld.pubDateShort": "Data de publicação",
  "ld.edition": "Edição",
  "ld.select": "Selecionar",
  "ld.subclass": "Subclasse",
  "ld.heading": "Cabeçalho",
  "ld.selectForEditing": "Selecione uma descrição de recurso para edição",
  "ld.startFromScratch": "Começar do zero",
  "ld.selectOrStartFromScratch": "{select} ou {startFromScratch}",
  "ld.backToTop": "Voltar ao topo",
  "ld.preview": "Prévia",
  "ld.confirmCloseRd": "Você realmente deseja fechar a descrição do recurso? Todas as alterações não salvas serão perdidas.",
  "ld.confirmDeleteRd": "Você realmente deseja excluir a descrição do recurso?",
  "ld.saveClose": "Salvar e fechar",
  "ld.close": "Fechar",
  "ld.delete": "Excluir",
  "ld.return": "Retornar",
  "ld.rdSaveSuccess": "Recurso criado. Espere um pequeno atraso até que o recurso fique visível no FOLIO.",
  "ld.rdUpdateSuccess": "Recurso atualizado. Espere um pequeno atraso até que as alterações sejam visíveis no FOLIO.",
  "ld.cantSaveRd": "Não é possível salvar a descrição do recurso",
  "ld.cantDeleteRd": "Não é possível excluir a descrição do recurso",
  "ld.rdDeleted": "Descrição do recurso excluído",
  "ld.appFail": "Ocorreu um erro. Por favor, recarregue a página.",
  "ld.searchSelectIndex": "Selecione um índice",
  "ld.advancedSearch": "Busca avançada",
  "ld.advanced": "Avançado",
  "ld.cancel": "Cancelar",
  "ld.loading": "Carregando...",
  "ld.paginationCount": "{startCount} - {endCount} de {totalResultsCount}",
  "ld.yes": "Sim",
  "ld.no": "Não",
  "ld.cantLoadSimpleLookupData": "Não é possível carregar dados para uma busca simples",
  "ld.publishDate": "Data de publicação",
  "ld.format": "Formato",
  "ld.suppressed": "Oculto",
  "ld.notSuppressed": "Não oculto",
  "ld.volume": "Volume",
  "ld.ebook": "Livro eletrônico",
  "ld.allTime": "Todo o tempo",
  "ld.past12Months": "Últimos 12 meses",
  "ld.past10Yrs": "Últimos 10 anos",
  "ld.past5Yrs": "Últimos 5 anos",
  "ld.customRange": "Faixa personalizada",
  "ld.all": "Todos",
  "ld.onlineResource": "Recurso online",
  "ld.startsWith": "Começa com",
  "ld.containsAll": "Contém todos",
  "ld.exactPhrase": "Frase exata",
  "ld.publisher": "Editora",
  "ld.creator": "Criador",
  "ld.language": "Idioma",
  "ld.classificationNumber": "Número de classificação",
  "ld.work": "Trabalho",
  "ld.instances": "Instâncias",
  "ld.noInstancesAvailable": "Nenhuma instância disponível.",
  "ld.noInstancesAdded": "Nenhuma instância adicionada",
  "ld.addAnInstance": "Adicionar uma instância",
  "ld.type": "Tipo",
  "ld.expandAll": "Expandir tudo",
  "ld.collapseAll": "Recolher tudo",
  "ld.showAllWithCount": "Mostrar tudo ({amt})",
  "ld.showAdditionalComponents": "Mostrar componentes adicionais ({amt})",
  "ld.hideAdditionalComponents": "Ocultar componentes adicionais",
  "ld.hide": "Ocultar",
  "ld.saveAndClose": "Salvar e fechar",
  "ld.saveAndContinue": "Salvar e continuar",
  "ld.editInstance": "Editar instância",
  "ld.editWork": "Editar trabalho",
  "ld.createInstance": "Criar instância",
  "ld.createWork": "Criar trabalho",
  "ld.saveAndKeepEditing": "Salvar e continuar editando",
  "ld.recordMappingToSchema": "Não é possível aplicar um registro ao esquema",
  "ld.newResource": "Novo recurso",
  "ld.addInstance": "Adicionar instância",
  "ld.compareSelected": "Comparar selecionados",
  "ld.newInstance": "Nova instância",
  "ld.newWork": "Novo trabalho",
  "ld.new": "Novo",
  "ld.cantSelectReferenceContents": "Não é possível selecionar o conteúdo de referência ao buscar uma referência",
  "ld.addNewInstance": "Adicionar nova instância",
  "ld.askSaveChangesBeforeProceeding": "Gostaria de salvar suas alterações antes de prosseguir?",
  "ld.unsavedRecentEdits": "As edições recentes feitas no recurso não foram salvas. As alterações não salvas serão perdidas.",
  "ld.unsavedChanges": "Alterações não salvas",
  "ld.continueWithoutSaving": "Continuar sem salvar",
  "ld.noTitleInBrackets": "Sem título",
  "ld.viewMarc": "Visualizar MARC",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "Não é possível carregar MARC para esta descrição de recurso",
  "ld.duplicate": "Duplicar",
  "ld.viewLinkedData": "Visualizar dados vinculados",
  "ld.viewInInventory": "Visualizar no aplicativo Inventário",
  "ld.authorityType": "Tipo de Autoridade",
  "ld.person": "Pessoa",
  "ld.source": "Fonte",
  "ld.family": "Família",
  "ld.organization": "Organização",
  "ld.meeting": "Reunião",
  "ld.corporateBody": "Entidade corporativa",
  "ld.jurisdiction": "Jurisdição",
  "ld.conference": "Conferência",
  "ld.authorizedReference": "Autorizada/Referência",
  "ld.headingReference": "Cabeçalho/Referência",
  "ld.unauthorized": "Não autorizado",
  "ld.assign": "Atribuir",
  "ld.assignAuthority": "Atribuir autoridade",
  "ld.change": "Mudar",
  "ld.searchCreatorAuthority": "Buscar autoridade do criador",
  "ld.selectMarcAuthority": "Selecione a autoridade MARC",
  "ld.marcAuthority": "Autoridade MARC",
  "ld.keyword": "Palavra-chave",
  "ld.recordsFound": "{recordsCount} registros encontrados",
  "ld.resourceWithIdIsEmpty": "Descrição do recurso {id} está vazio",
  "ld.duplicateInstance": "Instância duplicada",
  "ld.duplicateWork": "Trabalho duplicado",
  "ld.duplicateInstanceInBrackets": "(INSTÂNCIA DUPLICADA)",
  "ld.duplicateWorkInBrackets": "(TRABALHO DUPLICADO)",
  "ld.identifierAll": "Identificador (todos)",
  "ld.personalName": "Nome pessoal",
  "ld.corporateName": "Nome corporativo/conferência",
  "ld.geographicName": "Nome geográfico",
  "ld.nameTitle": "Nome-título",
  "ld.uniformTitle": "Título uniforme",
  "ld.subject": "Assunto",
  "ld.childrensSubjectHeading": "Cabeçalho de assunto do filho",
  "ld.genre": "Gênero",
  "ld.authoritySource": "Fonte da autoridade",
  "ld.references": "Referências",
  "ld.thesaurus": "Tesauro",
  "ld.typeOfHeading": "Tipo de cabeçalho",
  "ld.dateCreated": "Data de criação",
  "ld.dateUpdated": "Data de atualização",
  "ld.excludeSeeFrom": "Excluir VER DE",
  "ld.excludeSeeFromAlso": "Excluir Ver Também",
  "ld.previous": "Anterior",
  "ld.next": "Próximo",
  "ld.from": "De",
  "ld.to": "Para",
  "ld.apply": "Aplicar",
  "ld.notSpecified": "Não especificado",
  "ld.externalResourcePreview": "Prévia de recursos externos",
  "ld.errorFetchingExternalResourceForPreview": "Erro ao buscar recurso externo para prévia",
  "ld.fetchingExternalResourceById": "Buscando id de recurso externo {resourceId}...",
  "ld.lastUpdated": "Última atualização",
  "ld.marcAuthorityRecord": "Registro de Autoridade MARC",
  "ld.selectBrowseOption": "Selecione uma opção de navegação",
  "ld.searchQueryWouldBeHere": "{query} estaria aqui",
  "ld.continue": "Continuar",
  "ld.aria.filters.select": "Selecione identificadores de busca",
  "ld.aria.filters.textbox": "Caixa de texto de consulta de busca",
  "ld.aria.filters.reset": "Botão Redefinir filtros",
  "ld.aria.filters.reset.announce": "Campo de busca e filtros são redefinidos",
  "ld.backToInventory": "Voltar ao inventário",
  "ld.properties": "Propriedades",
  "ld.errorFetchingExternalResourceForEditing": "Erro ao buscar recurso externo para edição",
  "ld.duplicateImportWarn": "Aviso de importação duplicada",
  "ld.rdPropertiesMatchContinue": "As propriedades desse recurso correspondem a um recurso existente. Deseja continuar?",
  "ld.instance": "Instância",
  "ld.year": "Ano",
  "ld.aria.modal.close": "Fechar modal {modalKind}",
  "ld.aria.advancedSearch.queryInput": "Entrada de consulta de linha de pesquisa avançada",
  "ld.aria.advancedSearch.operator": "Operador de linha de pesquisa avançada",
  "ld.aria.advancedSearch.qualifier": "Qualificador de linha de pesquisa avançada",
  "ld.aria.advancedSearch.identifier": "Identificador de linha de pesquisa avançada",
  "ld.aria.listEntry.open": "Abrir entrada de lista retrátil",
  "ld.aria.listEntry.close": "Fechar entrada de lista retrátil",
  "ld.aria.table.selectRow": "Selecionar linha da tabela",
  "ld.aria.sections.openResourcePreview": "Abrir seção de prévia de recursos",
  "ld.aria.sections.closeResourcePreview": "Fechar seção de prévia de recursos",
  "ld.aria.edit.close": "Fechar página de edição",
  "ld.aria.edit.deleteComponent": "Excluir componente",
  "ld.aria.edit.duplicateComponent": "Componente duplicado",
  "ld.aria.resourcePreview.close": "Fechar painel de prévia de recursos",
  "ld.aria.externalResourcePreview.close": "Fechar página de prévia de recursos externos",
  "ld.aria.marcAuthorityPreview.close": "Fechar prévia da autoridade MARC",
  "ld.aria.marcPreview.close": "Fechar modal de prévia MARC",
  "ld.aria.complexLookup.marcPreview.close": "Fechar a seção de prévia do MARC",
  "ld.aria.edit.removeComplexLookupFieldValue": "Remover valor de campo de pesquisa complexo",
  "ld.errorMakingApiRequest": "Erro ao fazer requisição de API",
  "ld.compareResources": "Comparar recursos",
  "ld.selectedResources": "Recursos selecionados",
  "ld.nResourcesSelected": "{n} recursos selecionados",
  "ld.clearSelections": "Limpar seleções",
  "ld.chooseTwoResourcesCompare": "Escolha dois ou mais recursos para comparar",
  "ld.chooseOneResourceCompare": "Escolha outro recurso para comparar",
  "ld.aria.comparison.close": "Fechar seção de comparação",
  "ld.aria.comparison.removeEntry": "Remover entrada de comparação",
  "ld.aria.searchPane.close": "Fechar painel de busca",
  "ld.aria.searchPane.open": "Abrir painel de busca",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Aviso de autoridades não controladas",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `Esta descrição inclui uma ou mais autoridades não controladas. 
 Deseja salvar as alterações?`,
  "ld.errorAssigningAuthority": "Erro ao atribuir autoridade",
  "ld.errorAssigningAuthority.not_valid_for_target": "Selecione uma autoridade com um tipo de recurso que corresponda ao campo de autoridade editado (por exemplo, autoridade LCNAF para o campo Criador)",
  "ld.errorAssigningAuthority.no_lccn": "Somente autoridades da Biblioteca do Congresso podem ser atribuídas por enquanto. Isso é temporário até que tipos de fontes adicionais sejam suportados.",
  "ld.errorAssigningAuthority.unsupported_marc": "A autoridade selecionada não está mapeada para Dados Vinculados e ainda não pode ser atribuída. Isso é temporário, uma vez que o mapeamento MARC está em andamento.",
  "ld.required_primary_main_title": "Por favor, adicione o título principal para salvar.",
  "ld.lccn_does_not_match_pattern": "Validação do padrão LCCN ativada: Forneça um LCCN que esteja em conformidade com a estrutura padrão.",
  "ld.lccn_not_unique": "Exclusividade do LCCN ativada: O LCCN que você forneceu já existe. Forneça um LCCN diferente.",
  "ld.failed_dependency": "Não é possível verificar se o LCCN está duplicado.",
  "ld.not_found": "O ID do recurso foi alterado por outro usuário enquanto você tinha este recurso aberto. Atualize a janela do seu navegador.",
  "ld.mapping": "Houve um problema de mapeamento. Por favor, relate isso à sua equipe de suporte, com capturas de tela e um relato detalhado do que aconteceu.",
  "ld.generic_bad_request": "Houve um problema de interface do usuário. Por favor, relate isso à sua equipe de suporte, com capturas de tela e um relato detalhado do que aconteceu.",
  "ld.server": "Houve um problema no servidor. Por favor, relate isso à sua equipe de suporte, com capturas de tela e um relato detalhado do que aconteceu.",
  "ld.already_exists": "O mesmo ID de recurso já existe.",
  "ld.aria.sections.editInstance": "Editar instância: {title}"
};
export {
  e as default
};
